import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { CheckIcon, IconFillColor, IconSize, IconWrapper } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../translations';

import { StyledVisitHistoryPatientPregnancyMark } from './VisitHistoryPatientPregnancyMark.styled';

const StyledIconWrapper = styled(IconWrapper)`
   align-self: flex-start;
`;

export const VisitHistoryPatientPregnancyMark = (): JSX.Element => {
   return (
      <StyledVisitHistoryPatientPregnancyMark gap={'4px'} alignItems={'center'}>
         <StyledIconWrapper testId={'pregnancyConfirmed'} size={IconSize.SMALL} fillColor={IconFillColor.PRIMARY}>
            <CheckIcon />
         </StyledIconWrapper>
         <Translate>{visitPatientPregnancyStatusTranslationKeys.pregnancy}</Translate>
      </StyledVisitHistoryPatientPregnancyMark>
   );
};
